import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Validación Cruzada',
      text: 'Movistar le da a Punto de Fe una imagen de alcance nacional y modernidad. La marca aparece donde el usuario busca conexión.',
    },
    {
      title: 'Uso Orgánico',
      text: 'La marca aparece donde el usuario busca conexión, no donde lo interrumpe. Integración natural en el ecosistema de fe y esperanza.',
    },
    {
      title: 'Diferenciación',
      text: 'Mientras otros medios venden cuñas de 30 segundos, TNO le ofrece a Movistar ser el dueño de la red de fe en Venezuela.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Ventajas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Efecto de esta estructura
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
